import Image from "next/image";
import {
  BannerContainer,
  BannerTitleBackground,
  SubtitleContainer,
  TitleContainer,
} from "./styled";
import Typography from "../../../../components/Typography";

export default function Banner({ title, subtitle, background }) {
  return (
    <BannerContainer>
      <Image
        src={background.desktop}
        layout="fill"
        priority
        quality={50}
        objectFit="cover"
      />
      <TitleContainer>
        <Typography
          fontType="header"
          fontSize={"3rem"}
          color="darkGray2"
          fontWeight="bold"
          textAlign="center"
        >
          {title}
        </Typography>
      </TitleContainer>
      <SubtitleContainer width={subtitle.width} top={subtitle.top}>
        <Image
          alt="subtitle"
          {...subtitle.props}
          src={subtitle.src}
          layout="responsive"
          priority={true}
        />
      </SubtitleContainer>
    </BannerContainer>
  );
}
